import * as React from "react";
import clsx from "clsx";
import Icon, { ICON_SIZES } from "./Icon";

type PillButtonProps = {
  text: string;
  removeSelection?: Function;
};
const PillButton: React.FC<PillButtonProps> = ({ text, removeSelection }) => {
  return (
    <div
      className={clsx(
        "flex",
        "justify-start",
        "items-center",
        "pr-4",
        "pl-4",
        "py-1",
        "w-fit",
        "bg-slate",
        "rounded-2xl",
        "leading-none",
        "tracking-wider",
        "text-black",
        "bg-[#CDD5E0]",
        "text-[#677489]",
        "space-x-2"
      )}
    >
      <span className={clsx("text-xs")}>{text}</span>
      {removeSelection && (
        <button onClick={() => removeSelection()}>
          <Icon icon={"x"} size={ICON_SIZES.XS} />
        </button>
      )}
    </div>
  );
};

export default PillButton;
